import PropTypes from 'prop-types';
import React from 'react';
import { Button, Col, Row } from 'react-bootstrap';
import Modal from 'react-bootstrap/Modal';
import { connect } from 'react-redux';
import { modalAboutOnChangeAction } from '../../../stores/actions/modalOnChange';
import './aboutStyle.scss';

class About extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            show: true,
            buildInfo: {
                id: process.env.REACT_APP_BUILD_ID ? process.env.REACT_APP_BUILD_ID : '',
                version: process.env.REACT_APP_BUILD_VERSION ? process.env.REACT_APP_BUILD_VERSION : '',
                date: process.env.REACT_APP_BUILD_DATE ? process.env.REACT_APP_BUILD_DATE : '',
            },
        };
    }

    /**
     * Get about content from env
     */
    getAboutContent() {
        const { buildInfo } = this.state;

        return (
            <>
                <p>Version: {buildInfo.version}</p>
                <p>Build ID: {buildInfo.id}</p>
            </>
        );
    }

    /**
     * Handle popup close
     */
    handleClose = () => {
        this.setState({
            show: false,
        });
        this.props.setAboutClosed({ status: false });
    };

    /**
     * Ui rendering for class component
     */
    render() {
        //Set state variables for ui rendering
        const { show } = this.state;
        return (
            <>
                {/* Modal container for about */}
                <Modal className="modal-about" show={show} onHide={this.handleClose}>
                    <Modal.Header closeButton>
                        <Modal.Title>About - TherigyVista</Modal.Title>
                    </Modal.Header>
                    <Modal.Body>
                        <div className="body-content">
                            <Row>
                                <Col>{this.getAboutContent()}</Col>
                            </Row>
                        </div>
                        <div className="body-footer text-right">
                            <Button type="button" className="submit-btn" size="sm" onClick={this.handleClose}>
                                OK
                            </Button>
                        </div>
                    </Modal.Body>
                </Modal>
            </>
        );
    }
}

const MapDispatchToProps = (dispatch) => {
    return {
        setAboutClosed: (params) => dispatch(modalAboutOnChangeAction(params)),
    };
};

About.propTypes = {
    setAboutClosed: PropTypes.func.isRequired,
};

/**
 * Mapping redux state into props
 */
const MapStateToProps = () => {
    return {};
};

export default connect(MapStateToProps, MapDispatchToProps)(About);
